import { render, staticRenderFns } from "./SidebarImportContacts.vue?vue&type=template&id=7958f8ca&"
import script from "./SidebarImportContacts.vue?vue&type=script&lang=js&"
export * from "./SidebarImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./SidebarImportContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports